// extracted by mini-css-extract-plugin
export default {"homepage-wrapper":"home_homepage-wrapper__+jIzh","center":"home_center__zWKc1","section":"home_section__kIQX-","header-section":"home_header-section__mnwVg"};